// Aktuelles · Beiträge neueste zuerst. Kantstraßen-Sätze kommen aus kantstrasse.js.
import { KANT } from "./kantstrasse.js";

const R = "/media/realisiert";
const V = "/media/vorfuehrung";

export const NEWS_PATH = { de: "/aktuelles", en: "/en/news" };

export const NEWS_META = {
  de: {
    title: "Aktuelles | Berlin-Cube — Neuigkeiten zu Pilot, Vorführungen und Anwendungen",
    description:
      "Aktuelles von Berlin-Cube: Pilotanlage Kantstraße, Vorführung in Brandenburg, Zufahrtsschutz für die Weihnachtsmarkt-Saison — Neuigkeiten zum modularen System für den Schutz öffentlicher Räume.",
    h1: "Aktuelles",
    intro: "Neuigkeiten zu Pilotanlage, Vorführungen und Anwendungen von Berlin-Cube.",
    kicker: "Aktuelles",
    teaserKicker: "Aktuelles",
    all: "Alle Beiträge",
  },
  en: {
    title: "News | Berlin-Cube — updates on the pilot, demonstrations and use cases",
    description:
      "News from Berlin-Cube: the Kantstraße pilot, a demonstration in Brandenburg, vehicle access protection for the Christmas market season — updates on the modular system for protecting public spaces.",
    h1: "News",
    intro: "Updates on the pilot installation, demonstrations and use cases of Berlin-Cube.",
    kicker: "News",
    teaserKicker: "News",
    all: "All posts",
  },
};

export const NEWS = [
  {
    slug: "weihnachtsmarkt-saison-2026",
    date: "2026-09-29",
    de: {
      title: "Weihnachtsmarkt-Saison: Zufahrtsschutz jetzt planen",
      paragraphs: [
        "Die Planungen für die Weihnachtsmärkte laufen in vielen Städten gerade an. Wer Zufahrten sichern muss, hat meist drei Möglichkeiten: Betonblöcke, gemietete Sperren oder Poller. Berlin-Cube ist eine vierte: ein geprüftes Modul, das zugleich Sitzplatz, Stadtgrün und Treffpunkt ist.",
        "Geprüft ist das Modul im DEKRA-Crashtest nach IWA 14-1:2013 (Testfahrzeug 7.114 kg, 63,9 km/h, DEKRA-Prüfbericht Nr. 201844624). Aufgestellt wird ohne Fundament.",
      ],
      links: [
        { label: "Zufahrtsschutz für Weihnachtsmärkte", to: "/zufahrtsschutz-weihnachtsmarkt" },
        { label: "Förderleitfaden anfordern", to: "/?anliegen=foerderleitfaden#contact" },
      ],
    },
    en: {
      title: "Christmas market season: plan vehicle access protection now",
      paragraphs: [
        "Planning for the Christmas markets is getting under way in many cities. Anyone who has to secure access routes usually has three options: concrete blocks, rented barriers or bollards. Berlin-Cube is a fourth: a tested module that is at the same time a seat, urban greenery and a meeting place.",
        "The module is tested in a DEKRA crash test to IWA 14-1:2013 (test vehicle 7,114 kg, 63.9 km/h, DEKRA test report no. 201844624). It is set up without foundations.",
      ],
      links: [
        { label: "Vehicle security barriers for Christmas markets", to: "/en/vehicle-security-barriers-christmas-markets" },
        { label: "Request funding guide", to: "/en/?anliegen=foerderleitfaden#contact" },
      ],
    },
  },
  {
    slug: "vorfuehrung-wustermark",
    date: "2026-09-29",
    image: {
      src: `${V}/w_ebike_angle.jpg`,
      type: "vorfuehrung",
      alt: {
        de: "Berlin-Cube-Modul mit E-Bike-Ladestation und Baum bei der Vorführung in Wustermark, Brandenburg",
        en: "Berlin-Cube module with e-bike charging station and tree at the demonstration in Wustermark, Brandenburg",
      },
    },
    de: {
      title: "Drei Module, eine Rampe und ein Baum mit Ladekabel",
      paragraphs: [
        "An einem Outlet-Center in Wustermark, Brandenburg, haben wir Berlin-Cube Entscheidungsträgern aus Politik und Verwaltung vorgeführt – als befristete Vorführung. Drei Module standen in Reihe, verbunden durch befahrbare Rampen und taktile Bodenplatten. Ein Modul trug eine E-Bike-Ladestation mit zwei Ladepunkten und einen Baum obenauf, ein weiteres eine Werbefläche.",
        "Ein Grundsystem. Unterschiedliche Funktionen. Unterschiedliche Orte.",
      ],
      links: [{ label: "Schutz öffentlicher Räume", to: "/schutz-oeffentlicher-raeume" }],
    },
    en: {
      title: "Three modules, one ramp and a tree with a charging cable",
      paragraphs: [
        "At an outlet centre in Wustermark, Brandenburg, we demonstrated Berlin-Cube to decision-makers from politics and administration – as a temporary demonstration. Three modules stood in a row, connected by drivable ramps and tactile paving. One module carried an e-bike charging station with two charging points and a tree on top, another an advertising surface.",
        "One base system. Different functions. Different places.",
      ],
      links: [{ label: "Protecting public spaces", to: "/en/protecting-public-spaces" }],
    },
  },
  {
    slug: "kantstrasse-letzte-tage",
    date: "2026-09-29",
    image: {
      src: `${R}/02-gedaechtniskirche-tag.jpg`,
      type: "heute",
      alt: {
        de: "Berlin-Cube-Module mit Bäumen und Bänken in der Kantstraße in Berlin, im Hintergrund die Gedächtniskirche",
        en: "Berlin-Cube modules with trees and benches on Kantstraße, Berlin, with the Kaiser Wilhelm Memorial Church in the background",
      },
    },
    de: {
      title: "Kantstraße: Der Pilot geht in die letzten Tage",
      paragraphs: [
        KANT.de.whereStatus,
        "Über den Pilot berichteten unter anderem die rbb24 Abendschau, der Tagesspiegel, Entwicklungsstadt Berlin und die Berliner Morgenpost.",
      ],
      links: [{ label: "Begrünter Zufahrtsschutz statt Poller", to: "/begruenter-zufahrtsschutz-statt-poller" }],
    },
    en: {
      title: "Kantstraße: the pilot enters its final days",
      paragraphs: [
        KANT.en.whereStatus,
        "The pilot was covered by, among others, rbb24 Abendschau, Der Tagesspiegel, Entwicklungsstadt Berlin and Berliner Morgenpost.",
      ],
      links: [{ label: "Planted vehicle barriers instead of bollards", to: "/en/planted-vehicle-barriers-instead-of-bollards" }],
    },
  },
].sort((a, b) => (a.date < b.date ? 1 : a.date > b.date ? -1 : 0));

export const formatNewsDate = (iso, lang) =>
  new Intl.DateTimeFormat(lang === "en" ? "en-GB" : "de-DE", { day: "numeric", month: "long", year: "numeric" }).format(new Date(iso));

export const newsJsonLd = (lang, base) => ({
  "@context": "https://schema.org",
  "@graph": NEWS.map((n) => ({
    "@type": "Article",
    "@id": `${base}${NEWS_PATH[lang]}#${n.slug}`,
    headline: n[lang].title,
    description: n[lang].paragraphs[0],
    datePublished: n.date,
    dateModified: n.date,
    inLanguage: lang,
    ...(n.image ? { image: `${base}${n.image.src}` } : {}),
    mainEntityOfPage: `${base}${NEWS_PATH[lang]}`,
    author: { "@type": "Person", name: "Martin Fichtelmann" },
    publisher: { "@id": `${base}/#organization` },
  })),
});
